
import React from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box, Typography, Grid, Icon, GridList, GridListTile, Input, Button } from "@material-ui/core";
import withWidth from '@material-ui/core/withWidth';
import Layout from "../components/layout";
import revistaEDMImage from '../assets/revistas/EDM.png'
import revistaINTImage from '../assets/revistas/internacionalismo.png';
import edmData from '../assets/revistas/edm.json';

const useStyles = makeStyles(theme => ({
    boxContenedor:{
        position:'relative',
        textAlign:"center",
        margin:"2rem",
    },
    pageControls:{
      marginTop:"1rem",
      display:"flex",
      justifyContent:"center",
    },
    boxCenterControls:{
        width:"10rem",
        position:"relative",
    },  
    gridNotaItem:{
      marginBottom: '2rem',
      [theme.breakpoints.down('xs')]: {
        marginBottom: '1rem',
      }
    },
    boxRevistaHeader: {
      backgroundColor:"#E5332A",
      marginTop:"2rem", 
      padding:"3rem 3.5rem", 
      display:"flex", 
      justifyContent: "space-between",
      [theme.breakpoints.down('sm')]: {
        padding:"1rem 1.5rem",
        marginTop:"1rem",
      },
    },
    boxRevistaListaLabel: {display:"flex",flexDirection:"column"},
    labelRevistaBoldBlack: {
      color:"black",
      fontSize:"4rem",
      fontFamily:"FuturaBold",
      lineHeight:"1.5rem",
      marginTop:"2.7rem",
      [theme.breakpoints.down('sm')]: {
        fontSize:"1.3rem",
        marginTop:"0.3rem",
      },
    },
    labelRevistaBoldWhite: {
      color:"white",
      fontSize:"4rem",
      fontFamily:"FuturaBold",
      lineHeight:"1.5rem",
      [theme.breakpoints.down('sm')]: {
        fontSize:"1.3rem",
      },
    },
    labelRevistaBoldWhiteLittle: {
      color:"white",
      fontFamily:"FuturaBold",
      [theme.breakpoints.down('sm')]: {
        fontSize:"0.5rem",
      },
    },
    labelRevistaWhiteLittle: {
      color:"white",
      [theme.breakpoints.down('sm')]: {
        fontSize:"0.5rem",
      },
    },
    goButton:{
      marginLeft: '1rem',
      border: '1px solid black',
      padding: 0,
      minWidth: '2rem',
    },
}));

function RevistaEDMHeader() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>EDM</span>
        <span className={classes.labelRevistaBoldBlack}>En defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Nº 1 al 52</span>
        <span style={{color:"white"}}>(1991-2019)</span>
      </Box>
    </Box>
  );
};

function EDM(props) {
  const classes = useStyles();

  return (
    <Layout>
      <RevistaEDMHeader />
      <Box display="flex" justifyContent="center" mt="1.5rem">
        <a
          key="revista-internacionalismo"
          target="_blank"
          rel="noopener noreferrer"
          href="https://politicaobrera.com/revista/internacionalismo"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            borderBottom="2px solid black"
          >
            <img
              src={revistaINTImage}
              alt="Revista Internacionalismo"
              style={{ maxWidth: '10rem' }}
            />
            <Typography variant='h6'>Revisá también la revista Internacionalismo</Typography>
          </Box>
        </a>
      </Box>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Box style={{ padding: '2rem' }}>
          <Box style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            {edmData.map(item => (
              <Box key={item.id} style={{ border: '1px solid #ccc', padding: '1rem', borderRadius: '6px', maxWidth: "400px" }}>
                <Box display="flex" alignItems="center">
                  <img
                    src={revistaEDMImage}
                    alt={item.titulo}
                    style={{ width: 140, height: 180, objectFit: 'cover', marginRight: "2rem" }}
                  />
                  <Box display="flex" flexDirection="column" alignItems="flex-start">
                    <h3>{item.titulo}</h3>
                    <Box mb="20px">
                      <a href={item.url} target="_blank" rel="noopener noreferrer">
                        <Button variant='contained'>Ver</Button>
                      </a>
                    </Box>
                    <Box>
                      <a href={item.url} download>
                        <Button variant='contained'>Descargar</Button>
                      </a>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}

export default withWidth()(EDM);
